import type { IconDefinition } from '../index.tsx';

export const iconSidebarLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSidebarLeft',
  icon: [
    16,
    16,
    [],
    '',
    'M3 2.28H13A1.72 1.72 0 0 1 14.72 4V12A1.72 1.72 0 0 1 13 13.72H3A1.72 1.72 0 0 1 1.28 12V4A1.72 1.72 0 0 1 3 2.28ZM3 3.72A0.28 0.28 0 0 0 2.72 4V12A0.28 0.28 0 0 0 3 12.28H13A0.28 0.28 0 0 0 13.28 12V4A0.28 0.28 0 0 0 13 3.72H3ZM5.44684 3H6.84684V13H5.44684Z',
  ],
};
